// Internal helpers for the ui primitives (not re-exported from the barrel).
//   cx(...parts)   join truthy class names
//   vars(map)      typed inline CSS custom properties, e.g. vars({ "--v": 90 })
import type { CSSProperties } from "react";

export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

export function vars(map: Record<`--${string}`, string | number>, base?: CSSProperties): CSSProperties {
  return { ...base, ...map } as CSSProperties;
}
